const freeze = Object.freeze;

const SocketEvent = freeze({
  Connection: 'connection',
  JoinRoomSelf: 'JoinRoomSelf',
  OnJoinRoomSuccess: 'OnJoinRoomSuccess',
  LeaveRoom: 'leave_room'
})

export { SocketEvent }